import * as React from "react";
const SvgRadioSmall = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 8.5, fill: "none", stroke: "currentColor" })));
export default SvgRadioSmall;
